<template>
  <!-- Custom fonts for this template-->

  <link
    href="https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i"
    rel="stylesheet"
  />

  <div class="row">
<!--    &lt;!&ndash; Title &ndash;&gt;-->
<!--    <div class="stage-title">Power BI</div>-->
<!--    <hr />-->

    <iframe title="SprzedażApteki" width="1140" height="800.25" src="https://app.powerbi.com/reportEmbed?reportId=331ff7d2-2a4e-4179-8f96-a11a3bd86c9f&autoAuth=true&ctid=f7fd5f2a-1ba8-4675-9eab-e5b45744f209" frameborder="0" allowFullScreen="true"></iframe>
  </div>

</template>

<script>

import {useCommonAppModule} from "@/state/pinia/commonAppModule";

export default {
  name: "ReportsPowerBiStage",
  props: {},
  components: {
    // FontAwesomeIcon,
    // CommonChart,
  },
  data() {
    return {
      underConstructionWarningDisplayed: true,
    };
  },
  computed: {
    commonModule() {
      return useCommonAppModule();
    },
  },
  methods: {
  },
  created() {
  },
  mounted(){
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-bar-chart-alt-2"></i> Power BI`)
  },
};
</script>

<style scoped>

</style>
